import ProductUpdate from "./ProductUpdate";

export default ProductUpdate;
